import instance from "@/utils/request";

// 获取资源上传地址
export function getUploadUrl(value:any) {
    return instance.get('/store/v1/sign-upload-object',{
        params:value
    });
}

// 上传图片
export function uploadResource(url:any,value:any) {
    return instance.put(url,value);
}

// 获取国家
export function getCountry() {
    return instance.get('/cs/get_country');
}